import * as React from 'react';
import { CnCard as PCCnCard, CnCardSubCard as PCCnCardSubCard, } from '@cainiaofe/cn-ui';
export var CnCard = function (props) {
    var title = props.title, desc = props.desc, action = props.action, children = props.children, subTitle = props.subTitle, subDesc = props.subDesc, subAction = props.subAction;
    var displayChildren = children;
    if (subTitle) {
        displayChildren = (React.createElement(PCCnCardSubCard, { subTitle: subTitle, subDesc: subDesc, action: subAction }, displayChildren));
    }
    return (React.createElement(PCCnCard, { title: title, titleTips: desc, action: action }, displayChildren));
};
